/**
 * User-facing display names for roles.
 * Internal/API role names (e.g. "Tenant User (365 Tenant Sense)") are unchanged;
 * this mapping is for UI labels only (Sprint J).
 */

const ROLE_DISPLAY_NAMES: Record<string, string> = {
  'Tenant User (365 Tenant Sense)': 'Tenant User',
};

/**
 * Returns the display name for a role when shown in the UI.
 * If no mapping exists, returns the role as-is.
 */
export function getRoleDisplayName(role: string): string {
  if (!role || typeof role !== 'string') return role;
  return ROLE_DISPLAY_NAMES[role] ?? role;
}
